$(document).ready(function () {
    console.log('Cart limiter loaded!');

    function handleCartChange(cart) {
        var totalCount = cart.item_count;
        var currentTotalQuantity = 0;

        for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].quantity > 5) {
                currentTotalQuantity = 1;
            }
        }

        $('.cart-limit-reached').remove();

        if (currentTotalQuantity == 1 || totalCount > 20) {
            $('#slidecart-checkout-form button').prop('disabled', true);
            $('#slidecart-checkout-form').before(`<p class="cart-limit-reached">${cartStrings.limitReached}</p>`);
            $('.footer-continue').html('Sie können nicht mehr als 7 Produkte kaufen');
        } else {
            $('#slidecart-checkout-form button').prop('disabled', false);
            $('.footer-continue').html('Oder weiter einkaufen');
        }

        $('.wt-header__panel__counter').html(totalCount);
        if (totalCount > 0) {
            $('.wt-header__panel__counter').show();
        } else {
            $('.wt-header__panel__counter').hide();
        }

        const cartLoadedEvent = new CustomEvent("cart-loaded", {
            detail: cart
        });

        document.dispatchEvent(cartLoadedEvent);
    }

    function orderLimiter() {
        jQuery.getJSON("/cart.js", function (cart) {
            handleCartChange(cart);
        });
    }

    setInterval(orderLimiter, 1000);
});
